import React from 'react';
import { Box, Heading, Text, Button, Container, VStack } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

/**
 * NotFound component
 * Displays a 404 page when a route is not found
 */
const NotFound = () => {
  return (
    <Container maxW="container.md" py={20}>
      <VStack spacing={8} textAlign="center">
        <Heading as="h1" size="2xl">
          404
        </Heading>
        <Heading as="h2" size="xl">
          الصفحة غير موجودة
        </Heading>
        <Text fontSize="lg">
          عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.
        </Text>
        <Box>
          <Button
            as={Link}
            to="/"
            colorScheme="primary"
            size="lg"
          >
            العودة للصفحة الرئيسية
          </Button>
        </Box>
      </VStack>
    </Container>
  );
};

export default NotFound;
